import { useEffect, useRef } from "react";
import { INSTAGRAM_PROFILE_PERMALINK } from "@/data/social";

// Renders Instagram's official profile embed and processes it with embed.js.
export default function InstagramEmbed() {
  const ref = useRef(null);

  useEffect(() => {
    const process = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };
    const existing = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
    if (!existing) {
      const s = document.createElement("script");
      s.src = "https://www.instagram.com/embed.js";
      s.async = true;
      s.onload = process;
      document.body.appendChild(s);
    } else {
      process();
    }
  }, []);

  return (
    <div ref={ref} data-testid="instagram-live-feed" className="flex justify-center">
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={`${INSTAGRAM_PROFILE_PERMALINK}?utm_source=ig_embed&utm_campaign=loading`}
        data-instgrm-version="14"
        style={{
          background: "#FFF",
          border: 0,
          borderRadius: "12px",
          boxShadow: "0 1px 1px 0 rgba(0,0,0,0.06), 0 20px 60px -30px rgba(15,26,21,0.35)",
          margin: 0,
          maxWidth: "540px",
          minWidth: "326px",
          padding: 0,
          width: "100%",
        }}
      />
    </div>
  );
}
